import { CustomTextView } from "./CustomTextView";

interface props {
  title: string;
  size?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}

export const TitleView: React.FC<props> = ({ title, size = "h4" }: props) => {
  return <CustomTextView text={title} fontWeight="bold" variant={size}/>;
};
